<!--
 * @Descripttion: 审批列表
 * @Author: chenjinsheng
 * @Date: 2021-08-10 16:14:59
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-26 15:24:37
-->
<template>
    <div v-show="isAppShow" class="approval-container">
        <div class="approval-nav-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-if="checkPermission('UDWWB_MY_APPROVE')" label="我的审批" name="approval">
                    <my-approval-list @more="handleTask" />
                </el-tab-pane>
                <el-tab-pane v-if="checkPermission('UDWWB_MY_TASK_PLAN')" label="我的任务计划" name="task">
                    <my-task-list @more="toggleMore" />
                </el-tab-pane>
            </el-tabs>
            <div :class="['add-approval-btn', { 'guide-flow-container': steps.step3 }]">
                <el-button plain icon="el-icon-plus" size="mini" @click="open">发起申请</el-button>
            </div>
        </div>
        <div v-show="isTaskmore" class="more">
            <span :class="{ 'guide-more': steps.step3 }" @click="viewMore">查看更多</span>
        </div>
        <app-dialog ref="appDialog" @close="closeDialog"></app-dialog>
        <process-dialog ref="processDialog" @close="closeDialog"></process-dialog>
    </div>
</template>

<script>
import AppDialog from "./components/app-dialog";
import ProcessDialog from "./components/process-dialog";
import MyTaskList from "./components/my-task-list";
import MyApprovalList from "./components/my-approval-list";
import { customTrackEvent } from "@/libs/mUtils";
import { getProcessAuthById } from "@/api";
import { mapState } from "vuex";

export default {
    components: {
        AppDialog,
        ProcessDialog,
        MyTaskList,
        MyApprovalList,
    },
    data() {
        return {
            appType: 0,
            isApprovalMore: true,
            isTaskmore: true,
            activeName: "approval",
        };
    },
    computed: {
        ...mapState({
            switch: (state) => state.guide.switch,
            steps: (state) => state.guide.steps,
        }),
        isAppShow() {
            return [this.checkPermission("UDWWB_MY_APPROVE"), this.checkPermission("UDWWB_MY_TASK_PLAN")].some(Boolean);
        },
    },
    methods: {
        open() {
            customTrackEvent(() => {
                this.$ba.trackEvent("发起申请", "click", this.pointLabel);
            });
            this.isAuth();
            // todo 根据用户身份判断调用哪个发起弹框
            // this.$refs.appDialog.show();
            // this.$refs.processDialog.show();
        },
        toggleMore(status) {
            if (this.activeName === "task") {
                this.isTaskmore = status;
            }
        },

        closeDialog() {},

        handleClick({ name }) {
            if (name === "approval") {
                this.isTaskmore = true;
            }
        },
        search() {},
        // 查看全部
        viewAll() {
            this.handleRouterJump(
                2,
                `${this.$config.portalTaskOrign}/#/plan-task/task-mange/my-task?hidePageHeader=true`,
                "",
                true
            );
        },
        async isAuth() {
            try {
                const { code, message, body } = await getProcessAuthById({
                    username: this.userAuthName,
                });
                if (code === "0000") {
                    if (body) {
                        // this.$refs.processDialog.show();
                        this.$router.push({ name: "InitiationProcess" });
                        return;
                    }
                    this.$refs.appDialog.show();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
        },
        // 任务列表查看更多
        viewMore() {
            if (this.activeName === "approval") {
                this.$router.push({
                    name: "ApproveManage",
                    query: {
                        appType: this.appType,
                    },
                });
            } else {
                if (this.isTaskmore) {
                    this.viewAll();
                }
            }
            customTrackEvent(() => {
                this.$ba.trackEvent("我的审批查看更多", "click", this.pointLabel);
            });
        },
        handleTask(type) {
            this.appType = type;
        },
    },
};
// 材料看板
</script>

<style lang="scss" scoped>
@mixin center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.approval-container {
    position: relative;
    // width: 65%;
    // height: 520px;
    margin-top: 5px;
    height: 400px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 10px 20px 0 20px;
    box-sizing: border-box;
    .approval-nav-content {
        position: relative;
        display: flex;
        width: 100%;
        .add-approval-btn {
            position: absolute;
            right: 0;
            top: 10px;
            &.guide-flow-container {
                z-index: 100;
                background-color: #fff;
                border-radius: 2px;
                padding: 5px 4px;
                border: 2px solid #3a9d80;
                pointer-events: none;
            }
            /deep/ .el-icon-plus {
                &:before {
                    color: #3a9d80 !important;
                }
            }
            /deep/ .el-button--mini {
                color: #3a9d80;
                padding: 6px 15px;
            }
        }
        /deep/ .el-tabs {
            width: 100%;
        }
        /deep/ .el-tabs__item {
            font-weight: bold;
        }
        /deep/ .is-active {
            color: #3a9d80 !important;
        }
        /deep/ .el-tabs__header {
            margin-bottom: 0;
        }
        /deep/ .el-tabs__nav-wrap::after {
            background: none;
        }
    }
    .more {
        width: calc(100% - 40px);
        height: 43px;
        line-height: 43px;
        position: absolute;
        left: 20px;
        bottom: 0;
        text-align: right;
        font-size: 14px;
        color: #666666;
        border-top: 1px solid #e1e2e3;
        background: #fff;
        span {
            // padding: 0 15px;
            color: #3a9d80;
            padding-left: 15px;
            float: right;
            text-align: right;
            background: #fff;
            cursor: pointer;
        }
        .guide-more {
            display: inline-block;
            position: relative;
            z-index: 1000;
            padding-right: 15px;
            border: 2px solid #3a9d80;
            pointer-events: none;
        }
    }
}
</style>
